(function () {
    'use strict';

    angular.module("imApp").factory("acReportLayoutLineService", ['$ihttp', function ($ihttp) {
        let service = {
            getAcReportLayoutLine: function (parms) {
                return $ihttp.post({
                    method: 2806,
                    parameters: parms || {}
                });
            },
            listLineTypes: function (parms) {
                return $ihttp.post({
                    method: 2807,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2808,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 2813,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
